export const EVENT_NAME = {
  refetchPoolDetail: 'refetchPoolDetail',
  pollingBadGuys: 'pollingBadGuys',
  fetchInvoices: 'fetchInvoices',
};
